package com.havn.app.core.platform

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.havn.app.ui.theme.LocalHavnThemeTokens

@Composable
actual fun HavnQrScannerPreview(
    active: Boolean,
    cameraFacing: HavnCameraFacing,
    onQrScanned: (String) -> Unit,
    onError: (String) -> Unit,
    modifier: Modifier
) {
    val theme = LocalHavnThemeTokens.current
    if (active) {
        LaunchedEffect(Unit) {
            onError("QR scanning is available in the iOS and Android apps.")
        }
    }
    Box(
        modifier = modifier
            .border(BorderStroke(1.dp, theme.border)),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = "Open HAVN on iOS or Android to scan QR codes.",
            color = theme.secondaryText
        )
    }
}
